import { useRouter } from 'next/router';

import { PaymentLayout } from 'components/layouts';
import { PaymentPage } from 'components/pages/Payment/PaymentPage';
import { PaymentThemeProvider } from 'components/pages/Payment/PaymentThemeProvider';
import { EntryPoint, NextPageWithLayout } from 'utils/nextTypes';

const DepositPage: NextPageWithLayout = function DepositPage() {
  const router = useRouter();
  const depositIdParam = router.query.depositId;
  const depositId = typeof depositIdParam === 'string' ? depositIdParam : '';

  return <PaymentPage depositId={depositId} />;
};

DepositPage.getLayout = (page) => {
  return (
    <PaymentThemeProvider>
      <PaymentLayout>{page}</PaymentLayout>
    </PaymentThemeProvider>
  );
};
DepositPage.entryPointType = EntryPoint.PUBLIC;

export default DepositPage;
